import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import TkVisualizer from '@/../bower_components/teknisavuecomponents/components/document/TkVisualizer/TkVisualizer.vue';
import DocumentosController from '@/assets/ts/controller/DocumentosController';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import OfflineController from '@/assets/ts/controller/OfflineController';
import CordovaController from '@/assets/ts/controller/CordovaController';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import { ControleAcessoWrapper } from '@/assets/ts/controller/ControleAcessoController';

@Component({
  name: 'DocumentosDetalhes',
  components: {
    EditableTable,
    TkVisualizer,
  }
})
class DocumentosDetalhes extends Vue {
  // #region [ PROPS ]
  @Prop({ default: '' })
  private readonly nmCategoria: string;

  @Prop({ default: '' })
  private readonly nrCategoria: string;

  @Prop({ default: '' })
  private readonly nrVinculo: string;

  @Prop({ default: 0 })
  private readonly triggerReload: number;

  @Prop({ default: false })
  private readonly value: boolean;
  // #endregion

  // #region [ EVENTS ]
  @Emit('input')
  private emitInput(value: boolean) {}

  @Emit('add')
  private emitAdd() {}
  // #endregion

  //#region [ DATA ]
  private internalValue = false;

  private columns = [
    {
      value: 'NMANEXO',
      text: 'Nome',
      type: 'text',
    },
    {
      value: 'DSREFERENCIA',
      text: 'Referência',
      type: 'text',
    },
    {
      value: 'IDTYPE',
      text: 'Tipo',
      type: 'text',
    },
    {
      value: 'DTINCLUSAO',
      text: 'Data de Inclusão',
      type: 'date',
    },
  ];

  private documentos = [];

  private loading = false;

  private actions = [
    {
      name: 'view',
      label: 'Visualizar',
      icon: 'mdi-eye',
      onClick: this.view,
      mode: 'view',
    },
    {
      name: 'download',
      label: 'Baixar',
      icon: 'mdi-download',
      onClick: this.download,
      mode: 'view',
    },
    {
      name: 'delete',
      label: 'Excluir',
      icon: 'mdi-delete',
      onClick: ControleAcessoWrapper.deletar(this.delete),
      mode: 'view',
    },
  ];

  private toolbarActions = [
    {
      name: 'reload',
      label: 'Atualizar',
      icon: 'mdi-refresh',
      onClick: this.reloadDocumentos,
    },
    {
      name: 'add',
      label: 'Adicionar',
      icon: 'mdi-plus-circle',
      onClick: ControleAcessoWrapper.criar(this.add),
    },
  ];

  private visualizerPopup = {
    show: false,
    base64: '',
    mimeType: '',
  };
  //#endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      this.reloadDocumentos();
    }
  }

  @Watch('triggerReload')
  private trigeerReloadOnChange() {
    this.reloadDocumentos();
  }
  // #endregion

  // #region [ METHODS ]
  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  private async reloadDocumentos() {
    this.loading = true;
    this.documentos = [];

    try {
      const documentos = await DocumentosController.getDocumentosVinculo(
        this.nrVinculo, this.nrCategoria, false
      );

      documentos.forEach((doc) => {
        doc.DTINCLUSAO = doc.DTINCLUSAO.replace(' 00:00:00', '');
      });

      this.documentos = documentos;
    } finally {
      this.loading = false;
    }
  }

  private add() {
    this.emitAdd();
  }

  private async view(
    documento
  ) {
    this.loading = true;

    try {
      if (!this.fileIsSet(documento)) {
        await this.setFile(documento);
      }

      const file = documento.__file;
      const { base64, type } = file;

      const fullBase64 = FileUtils.getFullBase64(
        base64, type
      );

      this.visualizerPopup.show = true;
      this.visualizerPopup.base64 = fullBase64;
      this.visualizerPopup.mimeType = type;
    } finally {
      this.loading = false;
    }
  }

  private async download(
    documento
  ) {
    if(OfflineController.isMobile()) {
      try {
        await CordovaController.checkStorageAccessMobile();
      } catch (error) {
        const message = 'Permissões de armazenamento são necessárias para baixar o relatório. Por favor, revise as permissões e tente novamente.';
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
        return;
      }
    }
    this.loading = true;

    const fileName = documento.DSREFERENCIA;

    try {
      if (!this.fileIsSet(documento)) {
        await this.setFile(documento);
      }

      const file = documento.__file;

      const { type, base64 } = file;

      FileUtils.downloadBase64File(
        fileName, base64, type
      );

      setTimeout(() => {
        this.loading = false;
      }, 2000);
    } catch (err) {
      this.loading = false;
      throw err;
    }
  }

  private fileIsSet(
    documento
  ) {
    return documento.__file !== undefined;
  }

  private async setFile(
    documento
  ) {
    const nrAnexo = documento.NRANEXO;

    const file = await DocumentosController.downloadDocumento(
      nrAnexo, false
    );

    documento.__file = file;
  }

  private async delete(documento) {
    const nrAnexo = documento.NRANEXO;

    this.loading = true;
    try {
      await DocumentosController.deleteDocumento(nrAnexo);
      this.reloadDocumentos();
    } finally {
      this.loading = false;
    }

  }
  // #endregion
}

export default DocumentosDetalhes;